<template>

	<!-- Contents-->
	<div class="container">
		<div class="content">
			<section class="mypage">
				<div class="mypage_info" v-if="coAccountVO != null">

					<strong class="name">
						<span>{{ coAccountVO.nickName }}</span> 고객님,<br>
						반갑습니다.
					</strong>
					<div class="id">{{ coAccountVO.coEmailId }}</div>
					<ul>
						<li><router-link to="/mypage/infoForm">회원정보 수정</router-link></li>
						<li><a href="javascript:;" @click="doLogout">로그아웃</a></li>
					</ul>
				</div>
				<div class="mypage_menu">
					<ul>
						<li class="list1"><router-link to="/app/education/mine/">학습 현황</router-link></li>
						<li class="list2"><router-link to="/app/education/mine/wish/">관심 교육</router-link></li>
						<li class="list3"><router-link :to="'/app/board/site_qna?writerKey=' + getLoginId()">나의 문의</router-link></li>
						<li class="list4"><router-link to="/app/board/site_notice">공지사항</router-link></li>
					</ul>
				</div>
			</section>
		</div>
	</div>
	<!--//content -->

</template>

<script>
export default {
	name: "index",
	data() {

		return {

			coInfoVO: null,
			coAccountVO: null,

			isShowShopping: true,
			isShowSnsLogin: true,
		}
	},
	async created() {

		await !this.requireLogin(this, false)
		this.init();

	},
	mounted() {

	},
	methods: {

		init() {

			this.coAccountVO = this.getSessionProc();
			console.log(this.coAccountVO)
			this.getCompanyInfo();
		},


		async getCompanyInfo() {

			const self = this

			self.coInfoVO = await self.getCoInfoVO()
			// 아이폰이 경우 사이트 설정 따라가게 설정
			if (self.appDevice() === "IOS") {
				self.isShowShopping = self.coInfoVO.isIosShop
				self.isShowSnsLogin = self.coInfoVO.isIosSns
			}

		},


		plzWait() {

			// this.swalUtils.gritter("준비중", "정보조회를 위해 현재 준비중입니다.<br>잠시만 기다려주세요.", "info", 3000)
			this.swalUtils.gritter("준비중", "해당기능은 준비중입니다.<br>빨리 제공할 수 있게 준비중입니다.", "info", 3000)

		},

	}
}
</script>

<style scoped>

</style>
